module.exports = __webpack_public_path__ + "img/mobile-elbow-21_168x60.a2e73464.png";